"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SCHEMA = 'iglu:com.angi.entities/page_attributes/jsonschema/1-0-0';
/**
 * Generates the page_attributes context
 *
 * @param pageName - descriptive page name
 */
var pageAttributesContext = function pageAttributesContext(pageName) {
  return {
    schema: SCHEMA,
    data: {
      name: pageName
    }
  };
};
exports["default"] = pageAttributesContext;